import moment from 'moment'

export const projectName= "Signature Towers"
export const serverErrorMessage= "Something Went Wrong!"

export const custTime= "9 AM"

export const selectableTimes= ["9 AM", "10 AM", "11 AM", "12 PM", "1 PM", "2 PM", "3 PM", "4 PM", "5 PM", "6 PM", "7 PM", "8 PM", "9 PM"]

export const scheduleConfUrl = 'public_api/leads'
export const bookingUrl = 'public/bookings/new'

export const paymentPlans = ['CLP', 'EMI Scheme', 'EMI+CLP', 'Subvention 1:99', 'Subvention 10:90']

export function confCallParams(callParams){
  let toSend = {}
  toSend['name'] = callParams.custName
  toSend['email'] = callParams.custEmail
  toSend['phone'] = callParams.custPhone
  toSend['date'] = callParams.custDate ? moment(callParams.custDate).format("DD-MM-YYYY") : null
  toSend['time'] = callParams.custTime
  toSend['project'] = projectName
  return toSend
}

export function santizeBookingParams(bParams){
  let toSend = {}
  if(bParams.leadNo){
    toSend['ln'] = bParams.leadNo
  }else{
    toSend['p'] = projectName
  }
  toSend['t'] = bParams.typologyName
  toSend['f'] = bParams.floorName
  toSend['in'] = bParams.flatName
  toSend['wi'] = bParams.wingName
  toSend['pn'] = bParams.selectedPlan
  toSend['cpuu'] = bParams.cpId
  return toSend
}

export const masterJson = 
{
  "Buildings" : [
    {
      "uuid": "1",
      "key": "Wing 1",
      "value": "Wing 1",
      "status": "Sold",
      "opacity": "0.01",
      "fill": "#F5821F",
      "floor": "28",
      "path": "M699.5 221L753 221L753 377L753 381L753 391L753 404L753 520.5L698.5 520.5L698.5 514L661.5 514L661.5 520.5L610 520.5L610 476.5L615.5 476.5L615.5 469L675.5 469L675.5 428L624.5 428L624.5 397L618.5 397L618.5 381L613 381L613 268L608 268L608 253L611 253L611 221L617.5 221L662.5 221L662.5 226L699.5 226L699.5 221Z"
    },
    {
      "uuid": "2",
      "key": "Wing 2",
      "value": "Wing 2",
      "status": "Available",
      "opacity": "0.01",
      "fill": "#F5821F",
      "floor": "28",
      "path": "M619.5 381.5H311V397H318.5V428.5H343.5V477H312V520.5H610.5V477H584V453.5H576V428.5H610.5V397H619.5V381.5Z"
    },
    {
      "uuid": "3",
      "key": "Wing 3",
      "value": "Wing 3",
      "status": "Upcoming",
      "opacity": "0.01",
      "fill": "#F5821F",
      "floor": "28",
      "path": "M229.5 221L176 221L176 377L171 377L171 398.5L177 398.5L177 520.5L230.5 520.5L230.5 514L267.5 514L267.5 520.5L311 520.5L311 476.5L311 470.5L253.5 470.5L253.5 428L304.5 428L304.5 397L310.5 397L310.5 381L316 381L316 268L319 268L319 253L316 253L316 221L309.5 221L266.5 221L266.5 226L229.5 226L229.5 221Z"
    },
    {
      "key": "Park",
      "value": "Park",
      "status": "Available",
      "opacity": "0.01",
      "fill": "#F5821F",
      "image": "https://s3.ap-south-1.amazonaws.com/enrichr.biz.images/Goel_Ganga_Asmi_EOI_park-.png",
      "path": "M339.641 186.681L340.66 184.252C343.208 178.183 347.253 172.86 352.417 168.78C356.82 165.301 361.924 162.816 367.377 161.494L368.603 161.197C374.584 159.748 380.8 159.55 386.861 160.615L391.913 161.504C399.432 162.825 407.118 162.895 414.66 161.708L423.024 160.393C428.909 159.467 434.672 157.887 440.206 155.682L444.427 154L461.497 149.291C471.763 146.459 482.492 145.707 493.054 147.079C497.769 147.692 502.42 148.724 506.951 150.163L522.955 155.246C530.787 157.734 538.955 159 547.173 159H558.566C563.06 159 567.499 159.992 571.565 161.905C579.158 165.477 584.947 172.015 587.572 179.985L588.789 183.681C592.054 193.591 590.258 204.47 583.982 212.806C577.964 220.799 568.54 225.5 558.535 225.5H556.678C547.456 225.5 538.595 221.919 531.962 215.512L530.793 214.383C527.449 211.153 523.563 208.537 519.313 206.655L502.872 199.376C491.45 194.319 478.524 193.839 466.758 198.035C452.66 203.064 441.653 214.289 436.903 228.484L435.793 231.803C433.214 239.508 432.345 247.683 433.246 255.758L434.89 270.5L440.195 294.976C442.915 307.524 440.78 320.636 434.22 331.673C426.39 344.846 413.029 353.778 397.863 355.978L391.904 356.843C378.003 358.86 363.881 355.112 352.81 346.467C340.308 336.706 333 321.729 333 305.867V295.357C333 288.815 333.879 282.303 335.612 275.996L339.538 261.712C342.813 249.797 342.774 237.214 339.425 225.319L337.65 219.014C334.639 208.321 335.341 196.924 339.641 186.681Z"
    },
    {
      "key": "Play Area",
      "value": "Play Area",
      "status": "Available",
      "opacity": "0.01",
      "fill": "#F5821F",
      "image": "https://s3.ap-south-1.amazonaws.com/enrichr.biz.images/Goel_Ganga_Asmi_EOI_playground.png",
      "path": "M449.292 221.468L449.779 220.748C452.569 216.618 456.094 213.034 460.177 210.176C465.96 206.128 472.695 203.651 479.722 202.988L480.779 202.889C490.339 201.987 499.936 204.182 508.153 209.151L512.179 211.585C515.386 213.524 518.401 215.764 521.183 218.275L528.41 224.796C534.356 230.162 541.661 233.793 549.529 235.291L555.834 236.492C557.592 236.827 559.401 236.795 561.146 236.399L565.378 235.437C567.879 234.868 570.478 235.845 571.986 237.919C572.958 239.255 573.377 240.913 573.155 242.55L571 258.5V266.905C571 272.618 571.612 278.316 572.826 283.899L573.5 287L578 302L581.688 313.372C583.201 318.038 583.43 323.025 582.349 327.81C581.144 333.147 578.364 337.998 574.368 341.736L573.201 342.828C567.888 347.798 561.06 350.843 553.812 351.473L548.128 351.967C544.059 352.321 539.961 352.165 535.931 351.502L505.5 346.5L471.554 344.175C469.854 344.059 468.148 344.087 466.454 344.26L449.032 346.038C446.336 346.313 443.773 344.804 442.706 342.313C441.946 340.54 442.055 338.514 443 336.833L448.122 327.728C449.695 324.931 450.764 321.879 451.279 318.712L452.082 313.781C453.346 306.016 452.946 298.07 450.907 290.471L448.5 281.5L443.928 266.479C442.318 261.189 441.5 255.69 441.5 250.16V246.918C441.5 237.847 444.214 228.984 449.292 221.468Z"
    },

  ],
  "Variants" : [
    {
      "uuid": "1",
      "key": "floorseta",
      "value": "2BHK - Type 1",
      "price":"75 - 77L",
      "area":"692",
      "configuration":"2BHK",
      "TwoDImg": "https://s3.ap-south-1.amazonaws.com/enrichr.biz.images/ganga-goel+/2D-2BHK-t1.png",
      "ThreeDImg": "https://s3.ap-south-1.amazonaws.com/enrichr.biz.images/ganga-goel+/3D-2BHK-t1.png",
      "paths":[{
        "path":"M280 181.5H227V65.5H382.5V181.5H330V201H280V181.5Z",
        "fill":"#F5821F",
        "opacity":"0.01",
        "fillOpacity":"0.02"
      },{
        "path":"M434.5 182H383V65H538V182H484.5V201H434.5V182Z",
        "fill":"#F5821F",
        "opacity":"0.01",
        "fillOpacity":"0.02",
      },{
        "path":"M589 180H539V64.5H693V180H639.5V201.5H589V180Z",
        "fill":"#F5821F",
        "opacity":"0.01",
        "fillOpacity":"0.02",
      },{
        "path":"M227 452.5V336H280.5V316.5H329.5V339H355.5V354H382.5V452.5H227Z",
        "fill":"#F5821F",
        "opacity":"0.01",
        "fillOpacity":"0.02",
      },{
        "path":"M383 454V337H435.5V317H485V340H511.5V355H537V454H383Z",
        "fill":"#F5821F",
        "opacity":"0.01",
        "fillOpacity":"0.02",
      },{
        "path":"M692.5 453V336H639V317H590V339H564V354.5H537V453H692.5Z",
        "fill":"#F5821F",
        "opacity":"0.01",
        "fillOpacity":"0.02",
      }]
    },
    {
      "uuid": "2",
      "key": "floorsetb",
      "value": "2BHK - Type 2",
      "price": "79 - 81L",
      "area": "719",
      "configuration":"2BHK",
      "TwoDImg": "https://s3.ap-south-1.amazonaws.com/enrichr.biz.images/ganga-goel+/2D-2BHK-t2.png",
      "ThreeDImg": "https://s3.ap-south-1.amazonaws.com/enrichr.biz.images/ganga-goel+/3D-2BHK-t2.png",
      "paths":[{
        "path":"M173.5 361H201V336H189.5V276H120.5V338.5H43V452.5H97.5V443H126V452.5H173.5V361Z",
        "fill":"#F5821F",
        "opacity":"0.01",
        "fillOpacity":"0.02",
      }],
    },
    {
      "uuid": "3",
      "key": "floorsetc",
      "value": "2BHK - Type 3",
      "price": "85 - 87L",
      "area": "779",
      "configuration":"2BHK",
      "TwoDImg": "https://s3.ap-south-1.amazonaws.com/enrichr.biz.images/ganga-goel+/2D-2BHK-t3.png",
      "ThreeDImg": "https://s3.ap-south-1.amazonaws.com/enrichr.biz.images/ganga-goel+/3D-2BHK-t3.png",
      "paths": [{
        "path":"M693 453V335H715V338.5H876.5V453H821.5V442.5H794V453H693Z",
        "fill":"#F5821F",
        "opacity":"0.01",
        "fillOpacity":"0.02",
      }]
    },
    {
      "uuid": "4",
      "key": "floorsetd",
      "value": "3BHK",
      "price": "95 - 97L",
      "area": "903",
      "configuration":"3BHK",
      "TwoDImg": "https://s3.ap-south-1.amazonaws.com/enrichr.biz.images/ganga-goel+/2D-3BHK.png",
      "ThreeDImg": "https://s3.ap-south-1.amazonaws.com/enrichr.biz.images/ganga-goel+/3D-3BHK.png",
      "paths":[{
        "path":"M227 64V181.5H144V201H44V110H17V64H99V75.5H126V64H227Z",
        "fill":"#F5821F",
        "opacity":"0.01",
        "fillOpacity":"0.02",
      },{
        "path":"M776.5 180.5H693V66.5H794.5V75H821.5V66.5H902.5V110H875.5V201.5H776.5V180.5Z",
        "fill":"#F5821F",
        "opacity":"0.01",
        "fillOpacity":"0.02",
      }]
    }
  ],
}

export const FormSteps = ["Explore Project","Explore Master layout","Select Variant","Explore Unit Plan","KYC & Make Payment"]